import { FC, SVGProps } from "react";

interface MonitorCloudIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

// Lucide's monitor-cloud icon (ISC). Inlined because the installed
// lucide-react (0.323) predates it. Longer term, icon libraries should live
// in monolith-ui and be imported from there so the apps share one icon set
// instead of inlining one-offs like this.
export const MonitorCloudIcon: FC<MonitorCloudIconProps> = ({
  size = 24,
  ...props
}) => {
  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M11 13a3 3 0 1 1 2.83-4H14a2 2 0 0 1 0 4z" />
      <path d="M12 17v4" />
      <path d="M8 21h8" />
      <rect x="2" y="3" width="20" height="14" rx="2" />
    </svg>
  );
};

export default MonitorCloudIcon;
